@if ($pageState(); as vm) { @if (vm?.pageResponse?.content?.footer?.[0]) {
<!-- <custom-dot-editable-text [fieldName]="'body'" [contentlet]="contentlet" [format]="'html'" [mode]="'full'" /> -->
<custom-dot-cms-uve-edit-contentlet-wrapper [contentlet]="vm?.pageResponse?.content?.footer[0]" class="d-block">
  <div
    dotCmsUveSetAttributes
    [contentlet]="vm?.pageResponse?.content?.footer[0]"
    [mode]="'full'"
    [fieldName]="'body'"
    [setAttribute]="false"
    class="dot-cms-html-content default-web-page-content-class"
    [ishServerHtml]="vm?.pageResponse?.content?.footer[0].body"
  ></div>
</custom-dot-cms-uve-edit-contentlet-wrapper>
<ish-modal-dialog
  #conformDialog
  [options]="{
    confirmText: 'confirm',
    rejectText: 'cancel',
    titleText: 'Confirm Newsletter Subscription'
  }"
  (confirmed)="confirmMail()"
>
  Do you want enable Newsletter Subscription?
</ish-modal-dialog>
<!-- <dotcms-editable-text
  [fieldName]="'body'"
  [contentlet]="vm?.pageResponse?.content?.footer[0]"
  [format]="'html'"
  [mode]="'full'"
/> -->
<!-- }
 @else {
<div
  class="dot-cms-html-content default-web-page-content-class"
  [ishServerHtml]="vm?.pageResponse?.content?.footer[0]?.body"
></div>
}  -->
} }
